import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { BulkXRITMResponse } from "@/api/backofficeRest/generated/model"

// A one-off DCC read request that was accepted but failed downstream; the
// widget renders dedicated guidance for it rather than a generic error.
export const ONE_OFF_READ_REQUEST_FAILED = "OneOffReadRequestFailed"

export interface IFetchSmartReadMutator {
  fetchSmartRead(meterpointIdentifier: string): MutationResult<unknown>
}

class FetchSmartReadMutatorClass implements IFetchSmartReadMutator {
  fetchSmartRead(meterpointIdentifier: string) {
    if (!meterpointIdentifier)
      throw new Error("Missing required meterpoint identifier")

    const mutation =
      BackofficeRestMutations.meterpoints.fetchSmartRead(meterpointIdentifier)

    return useMutation({
      // Reject any per-meterpoint error so the widget's isError state fires
      // like it did for a failed Ark request. The OneOffReadRequestFailed
      // sentinel stays on the data path for the widget's dedicated copy.
      mutationFn: async () => {
        const response: BulkXRITMResponse = await mutation.mutationFn()

        for (const item of response ?? []) {
          if (item.error && !item.error.includes(ONE_OFF_READ_REQUEST_FAILED)) {
            throw new Error(item.error)
          }
        }

        return response
      },
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }
}

export const FetchSmartReadMutator = new FetchSmartReadMutatorClass()
